<div class="progress-bar" [ngClass]="{ 'progress-bar--not-visible': !isVisible }">
    <svg width="100%" height="4" focusable="false">
        <defs>
            <pattern x="4" y="0" width="8" height="4" patternUnits="userSpaceOnUse" id="progress-bar-pattern">
                <circle cx="2" cy="2" r="2"></circle>
            </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url('#progress-bar-pattern')"></rect>
    </svg>
    <div class="progress__bar-buffer" style="transform: scaleX(0)"></div>
    <div class="progress__bar-element" style="transform: scaleX(0)"></div>
</div>
